<template>
  <div>
    <v-tooltip bottom v-if="canShowDND">
      <template v-slot:activator="{ on, attrs }">
        <v-icon :color="colorDND" v-bind="attrs" v-on="on">
          mdi-minus-circle
        </v-icon>
      </template>
      <span>{{ $t('buddy.prefs.dnd' + (buddy.isDND ? 'On' : 'Off'))}}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canShowCFWD">
      <template v-slot:activator="{ on, attrs }">
        <v-icon :color="colorFwd" v-bind="attrs" v-on="on">
          mdi-phone-forward
        </v-icon>
      </template>
      <span>{{ $t('buddy.prefs.fwd' + (buddy.hasFwd ? 'On' : 'Off'))}}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canShowFME">
      <template v-slot:activator="{ on, attrs }">
        <v-icon :color="colorFme" v-bind="attrs" v-on="on">
          mdi-cellphone-arrow-down
        </v-icon>
      </template>
      <span>{{ $t('buddy.prefs.fme' + (buddy.hasFme ? 'On' : 'Off'))}}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'buddy-preferences',
  props: {
    buddy: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      showDND: 'permissions/showBuddyDND',
      showCFWD: 'permissions/showBuddyCFWD',
      showFME: 'permissions/showBuddyFME'
    }),
    canShowDND: function () {
      return this.showDND(this.buddy.id)
    },
    canShowCFWD: function () {
      return this.showCFWD(this.buddy.id)
    },
    canShowFME: function () {
      return this.showFME(this.buddy.id)
    },
    colorDND: function () {
      return this.buddy.isDND ? 'red' : 'grey lighten-2'
    },
    colorFwd: function () {
      return this.buddy.hasFwd ? 'orange' : 'grey lighten-2'
    },
    colorFme: function () {
      return this.buddy.hasFme ? 'amber' : 'grey lighten-2'
    }
  }
}
</script>

<style scoped>
i:hover {cursor: default}
</style>
